<div class="role-assign-user-select-modal" ngbAutofocus>
  <div class="modal-header">
    <div>
      <h5 class="modal-title">เลือกผู้รับมอบสิทธิ์</h5>
      <p class="modal-subtitle" id="role-assign-user-select-help">
        พบผู้ใช้หลายรายที่ตรงกับเลขประจำตัวนี้ กรุณาเลือกผู้ใช้ที่ต้องการ
      </p>
    </div>
    <button type="button" class="btn-close" (click)="cancel()" aria-label="ปิด"></button>
  </div>

  <div class="modal-body" aria-describedby="role-assign-user-select-help">
    <div class="selection-summary" role="status">
      <i class="bi bi-people" aria-hidden="true"></i>
      <span>พบผู้ใช้ {{ users.length }} รายการ</span>
    </div>

    <div class="user-list" role="listbox" aria-label="รายชื่อผู้รับมอบสิทธิ์">
      @for (user of users; track user.id ?? $index) {
        <button
          type="button"
          class="user-option"
          role="option"
          [disabled]="user.invitationAccepted"
          [class.disabled]="user.invitationAccepted"
          [attr.aria-disabled]="user.invitationAccepted ? true : null"
          (click)="!user.invitationAccepted && selectUser(user)"
          [attr.aria-label]="(user.name || 'ไม่ระบุชื่อ') + (user.invitationAccepted ? ' (ตอบรับคำเชิญแล้ว ไม่สามารถเลือกได้)' : '')">
          <span class="user-avatar" aria-hidden="true">
            @if (user.avatar && !hasAvatarError(user.id ?? $index)) {
              <img
                [src]="user.avatar"
                [alt]="user.name || 'รูปโปรไฟล์'"
                class="user-avatar-img"
                (error)="onAvatarError(user.id ?? $index)" />
            } @else {
              <i class="bi bi-person"></i>
            }
          </span>
          <span class="user-option-copy">
            <strong>{{ user.name || 'ไม่ระบุชื่อ' }}</strong>
            <span class="user-meta">
              <span>เลขประจำตัว: {{ user.taxId || '-' }}</span>
              <span class="user-meta-divider" aria-hidden="true">•</span>
              <span>รหัสอ้างอิง: {{ user.referenceCode || '-' }}</span>
            </span>
            @if (user.userTypes?.length) {
              <span class="user-types">
                @for (role of user.userTypes; track role) {
                  <span class="badge text-bg-light">{{ userRoleLabel(role) }}</span>
                }
              </span>
            }
          </span>
          @if (user.invitationAccepted) {
            <span class="badge bg-secondary-subtle text-secondary border border-secondary-subtle accepted-badge">ตอบรับคำเชิญแล้ว</span>
          } @else {
            <i class="bi bi-chevron-right user-option-arrow" aria-hidden="true"></i>
          }
        </button>
      }
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">ยกเลิก</button>
  </div>
</div>
